class GiftingBundle extends HTMLElement {
  constructor() {
    super();
    this.quantity = 1;
    this.initialTimer = null;
    this.handleQuantityUpdate = this.onQuantityBreaksUpdated.bind(this);
  }

  connectedCallback() {
    if (this.dataset.giftingInitialized === 'true') return;
    this.dataset.giftingInitialized = 'true';

    this.placeAfterOffers();
    document.addEventListener('quantity-breaks:updated', this.handleQuantityUpdate);
    this.initialTimer = window.setTimeout(this.handleQuantityUpdate, 100);
  }

  disconnectedCallback() {
    document.removeEventListener('quantity-breaks:updated', this.handleQuantityUpdate);
    if (this.initialTimer) window.clearTimeout(this.initialTimer);
    this.initialTimer = null;
    delete this.dataset.giftingInitialized;
  }

  placeAfterOffers() {
    if (this.dataset.autoPlace !== 'true' || this.dataset.giftingPlaced === 'true') return;

    const productForm = this.closest('[data-ref="product-form"]');
    const quantityBreaks = productForm?.querySelector('[data-ref="quantity-breaks"]');
    const offerGrid = quantityBreaks?.querySelector('[data-ref="qb-grid"]');
    if (!offerGrid) return;

    this.dataset.giftingPlaced = 'true';
    offerGrid.insertAdjacentElement('afterend', this);
  }

  onQuantityBreaksUpdated() {
    const productForm = this.closest('[data-ref="product-form"]');
    const selectedBreak = productForm?.querySelector('.quantity-break--selected');
    if (!selectedBreak) return;

    const newQuantity = parseInt(selectedBreak.dataset.quantity, 10);
    if (!newQuantity) return;

    this.quantity = newQuantity;
    this.updateGiftUnlocking();
  }

  updateGiftUnlocking() {
    this.querySelectorAll('.gifting-item').forEach((item) => {
      const tierRequired = parseInt(item.dataset.giftTier, 10) || 1;
      const ready = item.dataset.giftReady === 'true';
      const unlocked = ready && tierRequired <= this.quantity;
      const checkbox = item.querySelector('.gifting-checkbox');
      const status = item.querySelector('[data-gift-status]');

      item.classList.toggle('gifting-item--unlocked', unlocked);
      item.classList.toggle('gifting-item--locked', !unlocked);
      item.setAttribute('aria-label', `${item.querySelector('.gifting-name')?.textContent?.trim() || 'Cadeau'} — ${unlocked ? 'inclus' : `débloqué avec l’offre ${item.dataset.giftTierName || ''}`}`);

      if (checkbox) {
        checkbox.checked = unlocked;
        checkbox.disabled = true;
      }

      if (status) {
        status.textContent = ready
          ? (unlocked ? '✓ INCLUS' : `🔒 ${(item.dataset.giftTierName || '').toUpperCase()}`)
          : 'À CONFIGURER';
      }
    });
  }

  getSelectedGifts() {
    const gifts = [];
    const seenVariantIds = new Set();

    this.querySelectorAll('.gifting-checkbox:checked').forEach((checkbox) => {
      const variantId = parseInt(checkbox.dataset.variantId, 10);
      if (!variantId || seenVariantIds.has(variantId)) return;

      seenVariantIds.add(variantId);
      gifts.push({ id: variantId, quantity: 1 });
    });

    return gifts;
  }
}

if (!customElements.get('gifting-bundle')) {
  customElements.define('gifting-bundle', GiftingBundle);
}
